import { VerifiedBusiness } from 'services/businessBilling/contract';

export interface CompanyCardData {
    name: string;
    addressLines: string[];
    invoiceIdentifier?: string; // Exactly as returned by BOLT; never recomputed, prefixed or stripped.
}

const clean = (value?: string): string => (value ?? '').trim();

/**
 * What the card shows for a verified company. The address comes from the structured fields (never invented: a
 * missing part is skipped); the raw ANAF string is deliberately not displayed.
 */
export const toCompanyCardData = (company: VerifiedBusiness): CompanyCardData => {
    const { address } = company;
    const lines = [
        clean(address.line1),
        clean(address.line2),
        [clean(address.postalCode), clean(address.city)].filter(Boolean).join(' '),
        clean(address.region),
    ].filter(Boolean);
    const invoiceIdentifier = clean(company.tax.invoiceIdentifier);

    return {
        name: clean(company.name),
        addressLines: lines,
        ...(invoiceIdentifier ? { invoiceIdentifier } : {}),
    };
};
